export const ANALYSIS_TYPES = {
  DANINHAS: "DANINHAS",
  TAXA_VARIAVEL: "TAXA_VARIAVEL",
  ANALISE_BIOMASSA: "ANALISE_BIOMASSA",
  LINHAS_FALHAS: "LINHAS_FALHAS",
  CONTAGEM: "CONTAGEM",
  ANALISE_DE_COBERTURA: "ANALISE_DE_COBERTURA",
  ALTIMETRIA: "ALTIMETRIA",
}

export const ANALYSIS_TYPES_NAMES = {
  [ANALYSIS_TYPES.DANINHAS]: "Daninhas",
  [ANALYSIS_TYPES.TAXA_VARIAVEL]: "Taxa variavel",
  [ANALYSIS_TYPES.ANALISE_BIOMASSA]: "Análise de biomassa",
  [ANALYSIS_TYPES.LINHAS_FALHAS]: "Linhas e falhas",
  [ANALYSIS_TYPES.CONTAGEM]: "Contagem",
  [ANALYSIS_TYPES.ANALISE_DE_COBERTURA]: "Análise de cobertura",
  [ANALYSIS_TYPES.ALTIMETRIA]: "Altimetria",
}

export const ANALYSIS_TYPES_ICONS = {
  [ANALYSIS_TYPES.DANINHAS]: "weed",
  [ANALYSIS_TYPES.TAXA_VARIAVEL]: "variable-rate",
  [ANALYSIS_TYPES.ANALISE_BIOMASSA]: "biomass",
  [ANALYSIS_TYPES.LINHAS_FALHAS]: "lines-failures",
  [ANALYSIS_TYPES.CONTAGEM]: "count",
  [ANALYSIS_TYPES.ANALISE_DE_COBERTURA]: "coverage",
  [ANALYSIS_TYPES.ALTIMETRIA]: "altimetry",
}

export const POST_PROCESSING_STATUS = {
  WAITING_CONFIRMATION: "WAITING_CONFIRMATION",
  CONFIRMED: "CONFIRMED",
  PROCESSING: "PROCESSING",
  ENDED: "ENDED",
  ERROR: "ERROR"
}

export const POST_PROCESSINGS_STATUS_NAMES = {
  [POST_PROCESSING_STATUS.WAITING_CONFIRMATION]: {
    text: "Aguardando confirmação",
    class: "grey--text"
  },
  [POST_PROCESSING_STATUS.CONFIRMED]: {
    text: "Confirmado",
    class: "info--text"
  },
  [POST_PROCESSING_STATUS.PROCESSING]:  {
    text: "Processando",
    class: "grey--text text--darken-4"
  },
  [POST_PROCESSING_STATUS.ENDED]: {
    text: "Finalizado",
    class: "success--text"
  },
  [POST_PROCESSING_STATUS.ERROR]: {
    text: "Erro",
    class: "error--text"
  },
}
